








































import Vue from 'vue';
import SidePage from '../../common/components/ui/SidePage/index.vue';
import SubscribeCreate from '../../settings/components/subscribe/Create.vue';
import SubscribeList from '../../settings/components/subscribe/List.vue';
import accountVuex from '../../user/vuex/common';
import commonVuex from '../../common/vuex/common';
import Topic from '../models/Topic';

const topic: Topic | null = null;

export default Vue.extend({
  mixins: [accountVuex, commonVuex],
  components: {
    SidePage,
    SubscribeCreate,
    SubscribeList,
  },
  data() {
    return {
      showCreateSubscribe: false,
      loaded: false,
      refreshId: 0,
      topic,
    };
  },
  computed: {
    listLink(): string {
      if (this.account) {
        return `https://${this.account.domain}.weixin.drip.im/wx-wap/crm?special=${this.account.domain}&vuePath=topics`;
      } else {
        return '';
      }
    },
  },
  methods: {
    showEditBox(topic: Topic) {
      this.topic = topic;
      this.showCreateSubscribe = true;
    },
    onCopy() {
      this.$Message.success('复制成功');
    },
  },
});
